import { Injectable, inject } from '@angular/core';
import { User } from '@wilson/interfaces';
import { WilsonState } from '@wilson/non-domain-specific/decorators/wilson-state';
import { catchError, Observable, of, tap } from 'rxjs';
import { AccountService } from '../account.service';
import * as Sentry from '@sentry/capacitor';

@Injectable({
  providedIn: 'root',
})
export class UsersCacheService {
  private accountService = inject(AccountService);

  @WilsonState<Record<string, User>>({})
  private users!: Record<string, User>;

  getUserFromCache(id: string): Observable<User | null> {
    const user = this.users[id];
    if (user) {
      return of(user);
    } else {
      return this.accountService
        .get(id, {
          relations: ['accessibleOrganizationalUnits'],
        })
        .pipe(
          tap((user) => {
            this.users[user.id as string] = user;
          }),
          catchError((e) => {
            console.error('Error fetching user', e);
            Sentry.captureException(e);
            return of(null);
          }),
        );
    }
  }

  clearUserCache(): void {
    this.users = {};
  }
}
